import axios, { AxiosResponse, AxiosError } from 'axios';
import { useAuthStore } from '@/stores/authStore';


// Create axios instance
// Em produção: definir VITE_API_URL no build (ex: https://api.cobrancas.flyproject.com.br).
// Em dev: mesmo origin do Vite para usar o proxy (evita .env com porta antiga da API).
const viteEnv = (import.meta as any).env as { DEV?: boolean; VITE_API_URL?: string } | undefined;
const apiOrigin =
  viteEnv?.DEV && typeof window !== 'undefined'
    ? window.location.origin
    : (viteEnv?.VITE_API_URL ?? (typeof window !== 'undefined' ? window.location.origin : ''));
const API_BASE_URL = `${apiOrigin}/api/v1`;

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // Aumentar timeout para 60 segundos
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().accessToken;
    console.log('🔍 API Request - Token:', token ? 'Presente' : 'Ausente');
    console.log('🔍 API Request - URL:', config.url);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - simplificado pois o NetworkInterceptor já cuida dos erros
api.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log('✅ API Response - Status:', response.status);
    console.log('✅ API Response - Data:', response.data);
    return response;
  },
  (error: AxiosError) => {
    console.error('❌ API Response Error - Status:', error.response?.status);
    console.error('❌ API Response Error - Data:', error.response?.data);
    console.error('❌ API Response Error - Message:', error.message);
    // Deixa o NetworkInterceptor cuidar dos erros
    return Promise.reject(error);
  }
);

// Helper function to handle API responses
export const handleApiResponse = <T>(
  response: AxiosResponse<{ success: boolean; data: T; message?: string }>
): T => {
  if (response.data.success) {
    return response.data.data;
  } else {
    throw new Error(response.data.message || 'Erro desconhecido');
  }
};

// Helper function to handle API errors
export const handleApiError = (error: unknown): never => {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.message || error.message;
    throw new Error(message);
  } else if (error instanceof Error) {
    throw error;
  } else {
    throw new Error('Erro desconhecido');
  }
};
